import nengi from 'nengi'
import { uuid } from '../../utils/primitive-types'

class ItemListedSuccessfullyMessage {
	static protocol = {
		itemId: nengi.String,
	}
	itemId: uuid
	/**
	 * Creates an instance of ItemListedSuccessfullyMessage. This will scan the Stash to find a matching item.
	 * @param {uuid} itemId Item ID
	 * @memberof ItemListedSuccessfullyMessage
	 */
	constructor(itemId: uuid) {
		this.itemId = itemId
	}
}

export default ItemListedSuccessfullyMessage
